module.exports = __webpack_public_path__ + "static/force-dashcam-clip-vid-06c312a9d176810fca72144f6a99ac30.mp4";